import "../../App.css";

export const PrimaryLink = (props: { label: string, url: string }) => {
  return (
    <a
      className="Primary-link"
      href={props.url}
      target="_blank"
      rel="noopener noreferrer"
    >
      {props.label}
    </a>
  );
};
